import { getModel } from '../../model/registry'
import styled from "styled-components"
import useMobileNavBar from "../../hooks/useMobileNavBar"
import { useSnapshot } from "valtio";

//Import Sub-Components
import MobileNavItem from './MobileNavItem'

//Importing Icons to use
import * as AiIcons from 'react-icons/ai'

//Import utilities for the URL
import { useLocation } from 'react-router-dom'
import extractSlug from '../../utils/extractSlug'

import * as BsIcons from "react-icons/bs";

const moreItem = {
    title: 'More',
    icon: <BsIcons.BsThreeDots />,
}


const WrapperDiv = styled.div`
    position: fixed;
    bottom: 0px;
    height: 85px;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoint.xs}) {
        display: none;
    }
`

const PinnedDiv = styled.div`
    height: 85px;
    display: flex;
    padding-inline: 1rem;
    justify-content: space-between;
    background-color: ${({ theme }) => theme.nav.background};
    width: 100%;
    p {
        text-align: center;

    }
`

export const DeadSpace = styled.div`
    height:85px;
    display: block;

    @media (min-width: ${({ theme }) => theme.breakpoint.xs}) {
        display: none;
    }
`

const MobileNavBar = () => {
    const path = useLocation()
    const location = extractSlug(path.pathname).toUpperCase()
    const key = location.toLowerCase()
    const data = getModel('mobileNavBarData')[key]
    const { mobileNavBarState } = useMobileNavBar()
    const snap = useSnapshot(mobileNavBarState)

    return (
        snap.visible && <WrapperDiv name='mobileNavBar'>
            <PinnedDiv>
                {data.map(
                    (item, i) => {
                        return <MobileNavItem key={item.title || i} item={item} />
                    }
                )}
                <MobileNavItem key='mobile.bar.more' item={moreItem}></MobileNavItem>
            </PinnedDiv>
        </WrapperDiv>
    )
}

export default MobileNavBar
